import request from "./http";

class ApiAppRepository
{
    async create(apiApp) {
        const path = "api-apps/create";
        const method = "POST";
        const data = apiApp;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(apiApp) {
        const path = "api-apps/edit";
        const method = "POST";
        const data = apiApp;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async revoke(id) {
        const path = "api-apps/revoke";
        const method = "POST";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("revoke", error);
        }
    }

    async gridview(query) {
        const path = "api-apps/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("gridview", error);
        }
    }

    async details(id) {
        const path = "api-apps/details";
        const method = "POST";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("details", error);
        }
    }

    async refreshToken(id) {
        const path = "api-apps/refresh-token";
        const method = "POST";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("refreshToken", error);
        }
    }

}

export default ApiAppRepository;